import {Service} from "@/services/superclasses/service";

const api = window.contextPath + '/rest/access-tokens';

export class AccessTokenService extends Service {

    public create = async (): Promise<string> => {
        return this.data(await this.post<string>(api))
    };
}

export const accessTokenService = new AccessTokenService()